import { ITimeRangeValidationError, ITimerangeValue, TimerangeInputV2 } from '../../generic-components'
import { IValuePickerCommonOwnProps } from '../../value-picker'

interface ITimeRangePickerProps extends IValuePickerCommonOwnProps<ITimerangeValue> {}

const ITimeRangePicker = ({
    required,
    value,
    onChange,
    errors,
    valuePickerId,
    over24hHidden,
}: ITimeRangePickerProps): JSX.Element => {
    const typedError = errors as ITimeRangeValidationError

    return (
        <TimerangeInputV2
            required={required}
            value={value}
            errors={typedError}
            onChange={onChange}
            valuePickerId={valuePickerId}
            over24hHidden={over24hHidden}
        />
    )
}

export default ITimeRangePicker
